module.exports = __webpack_public_path__ + "img/EdTeacher.7afb9513.jpeg";